import { Grid } from '@mui/material'
import React from 'react'
import { heroHeaderContent } from 'src/types/components/shared/atom'
import HeaderCard from './headerCard/HeaderCard'
import HeaderTop from './headerTop/HeaderTop'
import useStyles from './Style'

interface IProps {
  zenMode: boolean
  color?: boolean
  content: heroHeaderContent
}
const Header: React.FC<IProps> = ({ zenMode, content, color }) => {
  const { classes } = useStyles()
  return (
    <Grid className={classes.rootContainer}>
      <HeaderTop zenMode={zenMode} content={content.headerText} />

      <Grid className={classes.headerCard}>
        <HeaderCard
          zenMode={zenMode}
          color={color}
          content={content.headerCard}
        />
      </Grid>
    </Grid>
  )
}

export default Header
